import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertPolicy } from "./ethicspolicyAPI";
import swal from 'sweetalert';
export interface InsertPolicyState {
  insertPolicy: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InsertPolicyState = {
    insertPolicy: [],
  status: "idle",
};

export const GetInsertPolicy = createAsyncThunk(
  "InsertPolicy/fetchInsertPolicy",
  async (data:any) => {
    const response = await fetchInsertPolicy(data);
    return response;
  }
);

export const InsertPolicySlice = createSlice({
  name: "InsertPolicy",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInsertPolicy.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInsertPolicy.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetInsertPolicy.fulfilled, (state, action) => {
        state.status = "idle";
        state.insertPolicy = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = InsertPolicySlice.actions;

export const selectInsertPolicy = (state: RootState) => {
  return state.InsertPolicy.insertPolicy;
};

export default InsertPolicySlice.reducer;
